import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitVehicleApplies = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const Helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth) //TODO: Revisar usuario

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormRequestGlobal = useForm(defaultData.defaultFormGlobal)
    const FormDeposit = useForm(defaultData.defaultFormDeposit)
    const FormPreInvventory = useForm(defaultData.defaultFormPreInventory)

    const Forms = {
        FormRequestGlobal,
        FormDeposit,
        FormPreInvventory,
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        // Helpers,
        //------------- Forms
        Forms 
    }



    const fetchAllVehicleApplication = useFetchData.useFetchAllVehicleApplications({...defaultFetchParams})
    const fetchAllCustomers = useFetchData.useFetchAllCustomers({...defaultFetchParams})
    const fetchAllVehicles = useFetchData.useFetchAllVehicles({...defaultFetchParams})
    const fetchAllQuotes = useFetchData.useFetchAllQuotes({...defaultFetchParams})
    const fetchInfoQuote = useFetchData.useFetchInfoQuote({...defaultFetchParams})
    const fetchInfoObservations = useFetchData.useFetchInfoObservations({...defaultFetchParams})
    const fetchAllFiles = useFetchData.useFetchAllFiles({...defaultFetchParams})
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({...defaultFetchParams})
    const fetchAllBanks = useFetchData.useFetchAllBanks({...defaultFetchParams})
    const fetchAllDeposits = useFetchData.useFetchAllDeposits({...defaultFetchParams})
    const fetchInfoDeposit = useFetchData.useFetchInfoDeposit({...defaultFetchParams})
    const fetchAllPreInventory = useFetchData.useFetchAllPreInventory({...defaultFetchParams})
    const fetchInfoPreInventory = useFetchData.useFetchInfoPreInventory({...defaultFetchParams})
    const fetchInfoApplication = useFetchData.useFetchInfoApplication({...defaultFetchParams})
    const fetchAllOrigins = useFetchData.useFetchAllOrigins({...defaultFetchParams})
    
    const FetchData = {
        fetchAllVehicleApplication,
        fetchAllOrigins,
        fetchAllCustomers,
        fetchAllVehicles,
        fetchAllQuotes,
        fetchInfoQuote,
        fetchInfoObservations,
        fetchAllFiles,
        fetchAllCashRegisters,
        fetchAllBanks,
        fetchAllDeposits,
        fetchInfoDeposit,
        fetchAllPreInventory,
        fetchInfoPreInventory,
        fetchInfoApplication,
    }

    const Actions = useActions({
        marvarApi, toggle, Helpers, user, 
        FetchData,
        globalStates,
        defaultData,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}